import { observer } from 'mobx-react';

import styles from './TableControls.tsx.module.scss';

import { SearchBar } from '@components/Table/SearchBar';
import { SearchParams } from '@components/Table/SearchBar/SearchBar';
import { ControlButton } from '@components/Table/ControlButton';
import { ButtonParams } from '@components/Table/ControlButton/ControlButton';
import {
    MeatballButton,
    MeatballButtonMenuItem,
    MeatballModifier,
    MeatballThemes,
} from '@components/ActionButtons/MeatballButton';

interface Props {
    searchParams?: SearchParams;
    searchValue?: string;
    mainButtonParams?: ButtonParams;
    additionalButtonsParams?: ButtonParams[];
    actions?: MeatballButtonMenuItem[];
    onSearchValueChange?(value: string): void;
}

export const TableControls = observer(
    ({ searchParams, searchValue, mainButtonParams, actions, additionalButtonsParams, onSearchValueChange }: Props) => {
        if (!searchParams && !additionalButtonsParams && !mainButtonParams && !actions) {
            return null;
        }

        return (
            <div className={styles.root}>
                {searchParams ? (
                    <SearchBar
                        searchParams={searchParams}
                        value={searchValue}
                        onChange={onSearchValueChange}
                    />
                ) : (
                    <div />
                )}
                {(mainButtonParams || actions) && (
                    <div className={styles.rightControls}>
                        {mainButtonParams && <ControlButton buttonParams={mainButtonParams} />}
                        {additionalButtonsParams &&
                            additionalButtonsParams.map(params => (
                                <ControlButton
                                    buttonParams={params}
                                    key={params.label}
                                />
                            ))}
                        {actions && (
                            <div className={styles.actions}>
                                <MeatballButton
                                    withIcon
                                    theme={MeatballThemes.Primary}
                                    modifiers={[MeatballModifier.InheritSize, MeatballModifier.CircledRadius]}
                                    items={actions}
                                />
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    },
);
